export class GameConfig {
  mode: string;
  submode: string;
  players: number;
  rounds: number;
  idletime: number;
  roundtime: number;
  jokers: boolean;
}
